
const overview = resolve => require(['@/components/orderNewAgent/overview'],resolve);
const goodsCompare = resolve => require(['@/components/orderNewAgent/goodsCompare'],resolve);
const bandAnalysis = resolve => require(['@/components/orderNewAgent/band'],resolve);
const structureCategory = resolve => require(['@/components/orderNewAgent/structureCategory'],resolve);
const sizeModel = resolve => require(['@/components/orderNewAgent/sizeModel'],resolve);
const kjTag = resolve => require(['@/components/orderNewAgent/kjTag'],resolve);
const areaOrderRank = resolve => require(['@/components/orderNewAgent/areaOrderRank'],resolve);
const tagSkc = resolve => require(['@/components/orderNewAgent/tagSkc'],resolve);
const bandColor = resolve => require(['@/components/orderNewAgent/bandColor'],resolve);
const price = resolve => require(['@/components/orderNewAgent/price'],resolve);
const mainPush = resolve => require(['@/components/orderNewAgent/mainPush'],resolve);
const topSkc = resolve => require(['@/components/orderNewAgent/topSkc'],resolve);
export default [
	{
		path : 'orderNewAgent/overview',
		name : 'overviewAgent',
		meta : {
			title : '整体概况',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : overview
	},
	{
		path : 'orderNewAgent/compare',
		name : 'goodsCompareAgent',
		meta : {
			title : '两年对比',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : goodsCompare
	},
	{
		path : 'orderNewAgent/band',
		name : 'bandAnalysisAgent',
		meta : {
			title : '波段指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : bandAnalysis
	},
	{
		path : 'orderNewAgent/sizeModel',
		name : 'sizeModelDistributionAgent',
		meta : {
			title : '尺码指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : sizeModel
	},
	{
		path : 'orderNewAgent/kjTag',
		name : 'kjTagAgent',
		meta : {
			title : '框架款指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : kjTag
	},
	{
		path : 'orderNewAgent/areaOrderRank',
		name : 'areaOrderRankAgent',
		meta : {
			title : '区域订量排名',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : areaOrderRank
	},
	{
		path : 'orderNewAgent/tag',
		name : 'tagSkcAgent',
		meta : {
			title : '标签指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : tagSkc
	},
	{
		path : 'orderNewAgent/bandColor',
		name : 'bandColorAgent',
		meta : {
			title : '色系指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : bandColor
	},
	{
		path : 'orderNewAgent/price',
		name : 'priceDistributionAgent',
		meta : {
			title : '价格指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : price
	},
	{
		path : 'orderNewAgent/structureCategory',
		name : 'structureCategoryAgent',
		meta : {
			title : '品类指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : structureCategory
	},
	{
		path : 'orderNewAgent/mainPush',
		name : 'mainPushAgent',
		meta : {
			title : '主推爆杆',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : mainPush
	},
	{
		path : 'orderNewAgent/topSkc',
		name : 'topSkcAgent',
		meta : {
			title : 'TOP指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : topSkc
	},
]



// WEBPACK FOOTER //
// ./src/router/orderNewAgent/index.js